module.exports = __webpack_public_path__ + "img/IPPR.ec3c6188.svg";